export async function fetchWithRetry(url, options, maxRetries = 3, retryDelay = 1000) {
	try {
		const response = await fetch(url, options);
		return response;
	} catch (error) {
		if (maxRetries <= 0) {
			throw error;
		}
		await new Promise(resolve => setTimeout(resolve, retryDelay));
		return fetchWithRetry(url, options, maxRetries - 1, retryDelay);
	}
}
